import axios from "axios"

const initializeApp = () => {

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'stage') {
        // dev code
        axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL_STAGE


    } else {
        axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL_PROD
        // Prod build code



        // Removing console.log from prod
        // console.log = () => {};


        // init analytics here
    }

}

export default initializeApp